(function () {
  var STYLE_ID = 'mc-sale-countdown-v2-style';

  function padTwo(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function ensureStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.pdp-sale-countdown{background:#0d0f14!important;border-top:1px solid rgba(204,248,50,.16)!important;border-bottom:1px solid rgba(204,248,50,.20)!important;color:#f7f8f0!important;font-variant-numeric:tabular-nums;position:relative;overflow:hidden;padding:0!important;display:block!important;}',
      '.pdp-sale-countdown:before{content:"";position:absolute;inset:0;background:linear-gradient(90deg,rgba(204,248,50,.18),transparent 22%,transparent 78%,rgba(204,248,50,.12)),radial-gradient(circle at 50% 0%,rgba(204,248,50,.16),transparent 42%);pointer-events:none;}',
      '.pdp-sale-countdown__inner{position:relative;z-index:1;display:grid;grid-template-columns:minmax(0,1fr) auto minmax(120px,auto);align-items:center;gap:18px;width:min(100%,1320px);min-height:58px;margin:0 auto;padding:9px clamp(18px,4vw,42px);}',
      '.pdp-sale-countdown__copy{display:flex;align-items:baseline;gap:10px;min-width:0;}',
      '.pdp-sale-countdown__label{display:inline-flex;align-items:center;color:#ccf832!important;font-size:11px!important;font-weight:850!important;letter-spacing:.12em!important;line-height:1;text-transform:uppercase;white-space:nowrap;}',
      '.pdp-sale-countdown__meta{color:rgba(247,248,240,.68);font-size:13px;line-height:1.3;white-space:nowrap;}',
      '.pdp-sale-countdown__timer{display:grid!important;grid-template-columns:repeat(4,minmax(48px,1fr));align-items:center;gap:6px;white-space:nowrap;color:#fff!important;font-size:15px!important;}',
      '.pdp-sale-countdown__time{display:grid;place-items:center;min-width:48px;padding:6px 8px 5px;border:1px solid rgba(255,255,255,.10);border-radius:7px;background:rgba(255,255,255,.07);box-shadow:inset 0 1px 0 rgba(255,255,255,.08);}',
      '.pdp-sale-countdown__unit{display:block;min-width:2ch;padding:0!important;border-radius:0!important;background:transparent!important;text-align:center;color:#fff!important;font-size:15px!important;font-weight:850!important;line-height:1;}',
      '.pdp-sale-countdown__unit-label{display:block;margin-top:3px;color:rgba(247,248,240,.54);font-size:9px;font-weight:800;letter-spacing:.08em;line-height:1;text-transform:uppercase;}',
      '.pdp-sale-countdown__msg{justify-self:end;display:inline-flex!important;align-items:center;justify-content:center;gap:5px;min-height:34px;padding:0 13px!important;border:1px solid rgba(204,248,50,.34);border-radius:999px;background:rgba(204,248,50,.10);color:rgba(247,248,240,.78)!important;font-size:13px!important;font-weight:650;white-space:nowrap;}',
      '.pdp-sale-countdown__msg strong{color:#ccf832!important;font-weight:900;margin-right:2px;}',
      '.pdp-sale-countdown.sale-countdown--ended{display:none!important;}',
      '@media (max-width:900px){.pdp-sale-countdown__inner{grid-template-columns:1fr;gap:9px;padding-top:12px;padding-bottom:12px}.pdp-sale-countdown__copy,.pdp-sale-countdown__msg{justify-self:center}.pdp-sale-countdown__timer{justify-self:center}}',
      '@media (max-width:640px){.pdp-sale-countdown__inner{min-height:0;gap:8px;padding:11px 14px}.pdp-sale-countdown__copy{flex-wrap:wrap;justify-content:center;row-gap:4px}.pdp-sale-countdown__meta{font-size:12px;white-space:normal;text-align:center}.pdp-sale-countdown__timer{width:min(100%,280px);grid-template-columns:repeat(4,minmax(0,1fr));gap:5px}.pdp-sale-countdown__time{min-width:0;padding:6px 4px 5px}.pdp-sale-countdown__unit{font-size:14px!important}.pdp-sale-countdown__msg{min-height:30px;font-size:12px!important}}'
    ].join('');

    (document.head || document.documentElement).appendChild(style);
  }

  function makeEl(tag, className, text) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = text;
    return el;
  }

  function makeTime(valueClass, label) {
    var wrap = makeEl('span', 'pdp-sale-countdown__time');
    wrap.appendChild(makeEl('span', 'pdp-sale-countdown__unit ' + valueClass, valueClass.indexOf('days') !== -1 ? '0' : '00'));
    wrap.appendChild(makeEl('span', 'pdp-sale-countdown__unit-label', label));
    return wrap;
  }

  function upgradeMarkup(container) {
    ensureStyles();
    if (container.querySelector('.pdp-sale-countdown__inner')) return;

    var existingStrong = container.querySelector('.pdp-sale-countdown__msg strong');
    var saveText = existingStrong ? existingStrong.textContent : '';
    var inner = makeEl('div', 'pdp-sale-countdown__inner');

    var copy = makeEl('span', 'pdp-sale-countdown__copy');
    copy.appendChild(makeEl('span', 'pdp-sale-countdown__label', 'Emotions week offer'));
    copy.appendChild(makeEl('span', 'pdp-sale-countdown__meta', 'Ends Tue, May 12 at 11:59 PM PT'));

    var timer = makeEl('span', 'pdp-sale-countdown__timer');
    timer.setAttribute('aria-label', 'Promotion countdown');
    timer.appendChild(makeTime('sale-countdown__days', 'Days'));
    timer.appendChild(makeTime('sale-countdown__hours', 'Hrs'));
    timer.appendChild(makeTime('sale-countdown__minutes', 'Min'));
    timer.appendChild(makeTime('sale-countdown__seconds', 'Sec'));

    var msg = makeEl('span', 'pdp-sale-countdown__msg');
    if (saveText) {
      msg.appendChild(makeEl('strong', '', saveText));
      msg.appendChild(document.createTextNode(' today'));
    } else {
      msg.textContent = 'Limited-time promo';
    }

    inner.appendChild(copy);
    inner.appendChild(timer);
    inner.appendChild(msg);
    container.textContent = '';
    container.appendChild(inner);
  }

  function updateCountdown(container) {
    var endDate = new Date(container.getAttribute('data-end-date')).getTime();
    var now = Date.now();
    var diff = endDate - now;

    if (diff <= 0) {
      container.classList.add('sale-countdown--ended');
      setValues(container, 0, '00', '00', '00');
      return false;
    }

    var totalSeconds = Math.floor(diff / 1000);
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    setValues(container, days, padTwo(hours), padTwo(minutes), padTwo(seconds));
    return true;
  }

  function setValues(container, days, hours, minutes, seconds) {
    var el;
    el = container.querySelector('.sale-countdown__days');
    if (el) el.textContent = days;
    el = container.querySelector('.sale-countdown__hours');
    if (el) el.textContent = hours;
    el = container.querySelector('.sale-countdown__minutes');
    if (el) el.textContent = minutes;
    el = container.querySelector('.sale-countdown__seconds');
    if (el) el.textContent = seconds;
  }

  function tick() {
    var containers = document.querySelectorAll('.sale-countdown');
    for (var i = 0; i < containers.length; i++) {
      if (containers[i].classList.contains('sale-countdown--ended')) continue;
      upgradeMarkup(containers[i]);
      updateCountdown(containers[i]);
    }
  }

  tick();
  setInterval(tick, 1000);
})();
